
































































import {Vue, Component} from 'vue-property-decorator'
import {months, years} from "@/views/Izvestaji/MonthsAndYears";
import moment from "moment";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import * as _ from 'lodash'
import numeral from "numeral"

@Component({})
export default class PrometPoDistributerima extends mixins(ComponentBaseMixin) {
  years = years;
  months = months;

  selectedYear: any = '';
  selectedMonth: any = '';
  isBusySearch = false;

  header = [];
  footer = [];
  body = [];

  created() {
    this.selectedYear = moment().year();
    this.selectedMonth = moment().month() + 1;
  }

  async getReport() {
    this.isBusySearch = true;
    await this.axios.get('api/reports/suppliers', {
      params: {
        year: this.selectedYear,
        month: this.selectedMonth
      }
    }).then(res => {
      this.prepareReport(res.data);
      this.isBusySearch = false;
    }).catch(err => {
      this.showError('neuspesnoUcitavanjePodataka');
      this.isBusySearch = false;
    });
  }

  prepareReport(data) {
    let suppliers = data.map(item => item.supplier).filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    this.header = suppliers;
    this.header.push(this.$i18n.t('ukupno'));

    let articles = data.map(item => item.article).filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    this.body = [];
    articles.forEach(article => {
      let row = [article];
      suppliers.forEach(supplier => {
        let cell = data.find(dataItem => {
          return dataItem.supplier === supplier && dataItem.article === article;
        });
        if (!cell && supplier === this.$i18n.t('ukupno')) {
          let totals = data.filter(item => {
            return item.article === article;
          });
          row.push(numeral(_.sumBy(totals, 'quantity')).format('0,0'));
          row.push(numeral(_.sumBy(totals, 'value')).format('0,0.00'));
          return;
        }
        row.push(numeral(cell ? cell.quantity : 0).format('0,0'));
        row.push(numeral(cell ? cell.value : 0).format('0,0.00'));
      });
      this.body.push(row);
    });

    this.footer = [];
    this.footer.push(this.$i18n.t('ukupno'));
    suppliers.forEach(supplier => {
      let cell = data.filter(dataItem => {
        return dataItem.supplier === supplier;
      });
      if (supplier === this.$i18n.t('ukupno')) {
        this.footer.push(numeral(_.sumBy(data, 'quantity')).format('0,0'));
        this.footer.push(numeral(_.sumBy(data, 'value')).format('0,0.00'));
        return;
      }
      this.footer.push(numeral(_.sumBy(cell, 'quantity')).format('0,0'));
      this.footer.push(numeral(_.sumBy(cell, 'value')).format('0,0.00'));
    });
    this.header.unshift(this.$i18n.t('artikal'));
  }
}
